import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ChatPage from 'pages/ChatPage/ChatPage';
import EmbedPage from 'pages/EmbedPage/EmbedPage';
import InAppPage from 'pages/InAppPage/InAppPage';
import { LanguageProvider } from 'contexts/LanguageContext';
import "assets/styles/scss/index.scss";

const App: React.FC = () => {
	return (
		<LanguageProvider>
			<Router>
				<Routes>
					<Route path="/" element={<ChatPage />} />
					<Route path="/embed" element={<EmbedPage />} />
					<Route path="/myMtnApp" element={<InAppPage />} />
				</Routes>
			</Router>
		</LanguageProvider>
	);
};
export default App;
